import axios from "axios";
import { Course, CoursePayload } from "../types/course.type";

const API_URL = import.meta.env.VITE_APP_API_URL;

export const fetchCourses = async (levelId?: number | string): Promise<Course[]> => {
	const url = levelId
		? `${API_URL}/admin/course/list?limit=1000&level_id=${levelId}`
		: `${API_URL}/admin/course/list?limit=1000`;
	const response = await axios.get(url);
	const resData = response.data?.data;
	if (Array.isArray(resData)) return resData;
	if (resData && Array.isArray(resData.items)) return resData.items;
	return [];
};

export const fetchCoursesByLevel = async (levelId: number | string): Promise<Course[]> => {
	const response = await axios.get(`${API_URL}/admin/course/by-level/${levelId}`);
	const resData = response.data?.data;
	if (Array.isArray(resData)) return resData;
	return [];
};

export const createCourse = async (payload: CoursePayload): Promise<any> => {
	const response = await axios.post(`${API_URL}/admin/course/add`, payload);
	return response.data;
};

export const updateCourse = async (
	id: number | string,
	payload: CoursePayload,
): Promise<any> => {
	const response = await axios.put(`${API_URL}/admin/course/edit/${id}`, payload);
	return response.data;
};

export const deleteCourse = async (id: number | string): Promise<any> => {
	const response = await axios.delete(`${API_URL}/admin/course/delete/${id}`);
	return response.data;
};
